
import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  NgZone
} from '@angular/core';

@Directive({
  selector: '[appClickOutsideDirective]'
})
export class ClickOutsideDirectiveDirective {
  // Coerce boolean inputs (handles strings ''/'true' from templates)
  private _enabled = true;

  @Input()
  set appClickOutsideEnabled(val: boolean | string | null | undefined) {
    this._enabled = val === '' ? true : !!val; // attribute without value => true
  }
  get appClickOutsideEnabled() {
    return this._enabled;
  }

  @Output() appClickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef, private ngZone: NgZone) { }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.handleEvent(event);
  }

  private handleEvent(event: Event) {
    if (!this._enabled) return;

    // Some browsers can have null target; default to document.body
    const target = (event?.target as Node) ?? document.body;

    // If the click is inside the element => ignore
    const host = this.elementRef.nativeElement as Node;
    const clickedInside = host === target || host.contains(target);
    if (clickedInside) return;

    // Run inside Angular zone to ensure UI updates
    this.ngZone.run(() => this.appClickOutside.emit());
  }
}
